import { APIClient } from "./axiosClient";

export class RedemptionMerchantApi {
  static fetchAllRedemptionMerchants(payload = { pageNumber: 0, pageSize: 0 }) {
    return APIClient(
      "/redemptionMerchant/getRedemptionMerchants",
      payload,
      { requestType: "post" }
    );
  }
} 